import type { ThemePreference } from "../api/types.js";

export const THEME_STORAGE_KEY = "provenance-theme";
export const THEME_DEFAULT_EPOCH_KEY = "provenance-theme-default-epoch";
export const THEME_DEFAULT_EPOCH = "provenance-brand-2026-10";
const LEGACY_THEME_STORAGE_KEY = "assure-theme";

type ThemeStorage = Pick<Storage, "getItem" | "setItem">;

export function isThemePreference(value: string | null): value is ThemePreference {
  return value === "vantablack" || value === "light" || value === "system";
}

/** Domain defaults apply only when the visitor has no saved preference. */
export function initialThemePreference(storage: ThemeStorage): ThemePreference {
  const fallback = "vantablack";
  try {
    const current = storage.getItem(THEME_STORAGE_KEY);
    const stored = current ?? storage.getItem(LEGACY_THEME_STORAGE_KEY);
    const preference =
      stored === "quantum" ? fallback : isThemePreference(stored) ? stored : fallback;
    if (current === null && stored !== null) storage.setItem(THEME_STORAGE_KEY, preference);
    return preference;
  } catch {
    return fallback;
  }
}
